var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"frame",staticClass:"gm-mailbaser-canvas",style:({ height: _vm.height + 'px' }),attrs:{"src":_vm.url,"title":"Form builder","sandbox":"allow-scripts allow-same-origin"}})
}
var staticRenderFns = []

export { render, staticRenderFns }